import {GET_VENDOR_MESSAGES} from './../actions/messages';

const initialState = {
    get_vendor_messages_waiting : false,
    get_vendor_messages_success : {},
    get_vendor_messages_error :{},
}

export default function messages(state = initialState, action){
    switch (action.type){
        case GET_VENDOR_MESSAGES:
            return {
                ...state,
                get_vendor_messages_waiting : action.get_vendor_messages_waiting,
                get_vendor_messages_success : action.get_vendor_messages_response,
                get_vendor_messages_error : action.get_vendor_messages_error
            }
        default:
            return state;
    }
}